<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-12 col-12">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a [routerLink]="['/']" href="javascript:void(0)">
                  <i class=" fas fa-home"></i>
                </a>
              </li>

              <li class=" breadcrumb-item">
                <a [routerLink]="['/funding-opportunities']" href="javascript:void(0)"> Funding opportunities </a>
              </li>


              <li class=" breadcrumb-item">
                <a href="javascript:void(0)"> {{ projectData.projectName }} </a>
              </li>
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)"> Emergency Grant Application </a>
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

<div class=" container-fluid mt--6">
  <section class="section" id="project-detail">
    <div class="row">
      <div class="col-lg-8 col-md-12 col-sm-12">
        <div class=" card-wrapper" id="projectInfo">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  <h3 class=" mb-0">Project Information</h3>
                </div>
              </div>


            </div>
            <div class="card-body">

              <div class="form-group">
                <h4>Name</h4>
                <p class="text-muted">{{ projectData.projectName }}</p>
              </div>
              <div class="form-group">
                <h4>Description</h4>
                <p class="text-muted">{{ projectData.projectDescription }}</p>
              </div>
              <div class="row">
                <div class="form-group  col-lg-4 col-md-4 col-sm-12">
                  <h4>Budget Frame</h4>
                  <p class="text-muted">{{ projectData.budgetFrame|number:'1.00' }}{{ " " }}{{ projectData.currencyCode }}</p>
                </div>
                <div class="form-group  col-lg-4 col-md-4 col-sm-12">
                  <h4>Application Deadline</h4>
                  <p class="text-muted">{{ projectData.dueDate|date:'dd/MM/yyyy' }}</p>
                </div>
                <div class="form-group  col-lg-4 col-md-4 col-sm-12">
                  <h4>Type of support</h4>
                  <ul style="list-style: none; padding-left: 0" class="text-muted">
                    <li *ngFor="let support of projectData.typeOfSupports">
                      {{ support.trim() }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-9 col-lg-9 col-sm-12">
                <h3 class=" mb-0">Documents</h3>
              </div>
            </div>
          </div>

          <div [formGroup]="fileForm" class="card-body">
            <app-upload-form
              [data]="files"
              [documentDatas]="documentDatas"
              [parentForm]="fileForm"
            >
            </app-upload-form>
          </div>
        </div>
      </div>
    </div>

  </section>

  <div class=" card-wrapper">
    <form (ngSubmit)="onSubmit()" [formGroup]="applicationForm">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-9 col-lg-9 col-sm-12">
              <h3 class=" mb-0">Application Information</h3>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="p-2 mb-2">
            <div class="row">
              <div class="col-md-6 col-lg-6 col-sm-12">
                <div class="form-group row">
                  <label class="col-md-3 col-form-label form-control-label">
                    Budget
                  </label>
                  <div class="col-md-9">
                    <input [ngClass]="{ 'is-invalid': applicationForm.get('budget')?.invalid
                               && applicationForm.get('budget')?.touched }"
                           class="form-control"
                           formControlName="budget"
                           type="number" step="1"
                           [min]="amountRange.min" [max]="amountRange.max">
                    <div *ngIf="applicationForm.get('budget')?.invalid && applicationForm.get('budget')?.touched" class="invalid-feedback">
                      <div *ngIf="applicationForm.get('budget')?.hasError('required')">Budget is required.</div>
                      <div *ngIf="applicationForm.get('budget')?.hasError('wholeNumber')">Please enter a whole number (no decimals).</div>
                      <div *ngIf="applicationForm.get('budget')?.hasError('min')">Budget cannot be negative.</div>
                      <div *ngIf="applicationForm.get('budget')?.hasError('max')">Budget cannot exceed {{ amountRange.max | number }}.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-6 col-sm-12">
                <div class="form-group row">
                  <label class="col-md-3 col-form-label form-control-label">
                    Currency
                  </label>
                  <div class="col-md-9">
                    <select [ngClass]="{ 'is-invalid': applicationForm.get('currencyId')?.invalid
                               && applicationForm.get('currencyId')?.touched }"
                            class="form-control"
                            formControlName="currencyId" id="currencyDdl">
                      <option *ngFor="let value of currency" [value]="value.id">{{ value.name }}</option>

                    </select>
                    <div class="invalid-feedback">
                      Currency is required.
                    </div>
                  </div>
                </div>
              </div>


            </div>
            <div class="form-group">
              <label class="form-control-label">
                Application Title
              </label>
              <p class="text-muted small" style="display: block">
                Please write the title in English and use no more than {{ limits.applicationName }} characters (spaces included)
              </p>
              <input [ngClass]="{ 'is-invalid': applicationForm.get('applicationName')?.invalid
                               && applicationForm.get('applicationName')?.touched }" class="form-control"
                     formControlName="applicationName"
                     type="text"
                     [maxlength]="limits.applicationName">
              <app-char-counter [control]="applicationForm.get('applicationName')"
                                [max]="limits.applicationName"></app-char-counter>
              <div class="invalid-feedback">
                <div *ngIf="applicationForm.get('applicationName')?.hasError('required')
                            || applicationForm.get('applicationName')?.hasError('notBlank')">
                  Application Title is required.
                </div>
                <div *ngIf="applicationForm.get('applicationName')?.hasError('maxlength')">
                  Application Title cannot exceed {{ limits.applicationName }} characters.
                </div>
                <div *ngIf="applicationForm.get('applicationName')?.hasError('englishOnly')">
                  Application Title must contain only English characters and basic special characters (no other languages allowed).
                </div>
              </div>
            </div>

            <div class="form-group">
              <label style="display: block" class="form-control-label">
                Purpose of Emergency support (Max {{ limits.fundingPupose }} characters)
              </label>
              <ul class="text-muted small" style="list-style-type: none; padding: 0;">
                <li>Please provide a short explanation of why you need emergency support,</li>
                <li>and in what way this support will help you to improve/solve the situation,</li>
                <li>or how the actions you will undertake with the emergency assistance will improve the situation</li>
              </ul>
              <textarea class="form-control"
                        [ngClass]="{ 'is-invalid': applicationForm.get('fundingPupose')?.invalid
                               && applicationForm.get('fundingPupose')?.touched }"
                        rows="7" formControlName="fundingPupose"></textarea>
              <app-char-counter [control]="applicationForm.get('fundingPupose')"
                                [max]="limits.fundingPupose"></app-char-counter>
              <div class="invalid-feedback">
                <div *ngIf="applicationForm.get('fundingPupose')?.hasError('required')
                            || applicationForm.get('fundingPupose')?.hasError('notBlank')">
                  Purpose of Emergency support is required.
                </div>
                <div *ngIf="applicationForm.get('fundingPupose')?.hasError('maxlength')">
                  Purpose of Emergency support cannot exceed {{ limits.fundingPupose }} characters (a line break counts as two).
                </div>
              </div>
            </div>

            <div class="form-group">
              <label style="display: block" class="form-control-label">
                Explanation of costs (Max {{ limits.costExplanation }} characters)
              </label>
              <ul class="text-muted small" style="list-style-type: none; padding: 0;">
                <li>Please explain how you will use the emergency funds.</li>
                <li>For amounts above 1000 EUR/USD, please attach a budget.</li>
              </ul>
              <textarea class="form-control"
                        [ngClass]="{ 'is-invalid': applicationForm.get('costExplanation')?.invalid
                               && applicationForm.get('costExplanation')?.touched }"
                        rows="7" formControlName="costExplanation"></textarea>
              <app-char-counter [control]="applicationForm.get('costExplanation')"
                                [max]="limits.costExplanation"></app-char-counter>
              <div class="invalid-feedback">
                <div *ngIf="applicationForm.get('costExplanation')?.hasError('required')
                            || applicationForm.get('costExplanation')?.hasError('notBlank')">
                  Explanation of costs is required.
                </div>
                <div *ngIf="applicationForm.get('costExplanation')?.hasError('maxlength')">
                  Explanation of costs cannot exceed {{ limits.costExplanation }} characters (a line break counts as two).
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-control-label">
              Emergency Funds Target
            </label>
            <select class="form-control"
                    [ngClass]="{ 'is-invalid': applicationForm.get('fundingTarget')?.invalid
                               && applicationForm.get('fundingTarget')?.touched }"
                    formControlName="fundingTarget">
              <option *ngFor="let value of fundTarget" [value]="value.id">{{ value.name }}</option>

            </select>
            <div class="invalid-feedback">
              Emergency Funds Target is required.
            </div>
          </div>

        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <button class="btn btn-primary" type="submit">Submit</button>
          <button class="btn btn-outline-primary" type="button" (click)="onSaveDraft()">Save Draft</button>
          <button [routerLink]="['/funding-opportunities']" class="btn btn-secondary" type="button">Back</button>
        </div>
      </div>

    </form>


  </div>
</div>
